import React, { useState } from 'react';
import DialogBox from 'components/dialog';
import { H5 } from 'components/reusable-css';
import * as Styles from '../style';
import { Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import Input from 'components/input';
import CustomButton from 'components/common/custom-button';

const CreateTemplate = ({ label, setLabel, openFilter, handleClose, handleNameSubmit, isLoading }) => {
  const { t } = useTranslation();
  const [labelError, setLabelError] = useState(false);

  return (
    <DialogBox crossButton width="sm" open={openFilter} onClose={handleClose}>
      <Styles.RenameModal>
        <H5>{t('vs/firewall.string16')}</H5>
        <Styles.GreyBorder />
        <Styles.NewTag>
          <Input
            type="text"
            styling={{ fontSize: '16px', marginBottom: '0' }}
            focusName="firewall_template"
            name="firewall_template"
            value={label}
            tooltipStyles={{
              leftPosition: '8%',
              headingSize: '11px',
              descriptionSize: '11px',
              minWidth: '80%',
              bottomPosition: '65px',
              arrowSize: '18px',
            }}
            onChange={async (e) => {
              setLabel(e.target.value);
              const isValid = label.length == 0;
              setLabelError(isValid);
            }}
            loading={isLoading}
            inputProps={{
              maxlength: 64,
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleNameSubmit(label);
              }
            }}
            touched
            error={labelError ? 'vs/firewall.string17' : ''}
            placeholder={t('vs/firewall.string18')}
            isFormIk={false}
            EndAdornment={() => (
              <span onClick={() => handleNameSubmit(label)}>
                <Icon name="save" />
              </span>
            )}
          />
        </Styles.NewTag>
        <Styles.ButtonContainer>
          <CustomButton
            disabled={isLoading || label.length == 0}
            title={'vs/firewall.string19'}
            isLoading={isLoading}
            onClick={() => handleNameSubmit(label)}
            rightIcon={<Icon name="angle left" />}
          />
        </Styles.ButtonContainer>
      </Styles.RenameModal>
    </DialogBox>
  );
};

export default CreateTemplate;
